import OAuthCallback from '../OAuthCallback.jsx';

const StripeOAuthCallback = ({}) => {
    return <OAuthCallback route="/api/integrations/stripe/oauth" />;
};

export default StripeOAuthCallback;
